module.exports = __webpack_public_path__ + "img/ck-wiki-tip-bg.8453da84.png";